import { buttonConfigs } from '@/components/custom/arito/custom-input-table/components/action-button-set';
import { AritoIconActionButton, type ButtonType } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

interface ButtonConfig {
  type: ButtonType;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  icon?: number;
}

interface InputTableActionBarProps {
  mode: FormMode;
  handleAddRow?: () => void;
  handleDeleteRow?: () => void;
  handleCopyRow?: () => void;
  handlePasteRow?: () => void;
  handleMoveRow?: (direction: 'up' | 'down') => void;
}

const renderActionButton = (button: ButtonConfig): React.ReactNode => {
  let icon: number;
  let title: string;

  if (button.icon !== undefined && button.title) {
    icon = button.icon;
    title = button.title;
  } else {
    const config = buttonConfigs[button.type] || { icon: 0, title: '' };
    icon = config.icon;
    title = config.title;
  }

  const isDisabled = button.disabled || false;

  return <AritoIconActionButton title={title} icon={icon} onClick={button.onClick} disabled={isDisabled} />;
};

export default function InputTableActionBar({
  mode,
  handleAddRow,
  handleDeleteRow,
  handleCopyRow,
  handlePasteRow,
  handleMoveRow
}: InputTableActionBarProps) {
  const buttonTypes: ButtonType[] = ['add', 'delete', 'copy', 'paste', 'moveUp', 'moveDown', 'export', 'pin'];

  const buttonActions = {
    add: () => handleAddRow?.(),
    delete: () => handleDeleteRow?.(),
    copy: () => handleCopyRow?.(),
    paste: () => handlePasteRow?.(),
    moveUp: () => handleMoveRow?.('up'),
    moveDown: () => handleMoveRow?.('down'),
    export: () => console.log('Export clicked'),
    pin: () => console.log('Pin clicked')
  } as Record<ButtonType, () => void>;

  const buttons: ButtonConfig[] = buttonTypes.map(type => ({
    type,
    onClick: buttonActions[type],
    disabled: mode === 'view'
  }));

  return (
    <div className='flex h-9 flex-none items-center justify-between border-b border-gray-200 bg-white px-1 py-0'>
      <div className='flex h-full flex-1 items-center justify-between'>
        <div className='flex items-center'>
          {buttons.map((button, index) => (
            <span key={button.type + index}>{renderActionButton(button)}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
